import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * On a 401 from any endpoint (except the refresh endpoint itself), silently calls
 * POST /Auth/RefreshToken. If the backend issues a new session cookie the original
 * request is retried. If the refresh also fails the user is redirected to /login
 * via a full page reload (handled by the error interceptor on the second 401).
 */
export const tokenRefreshInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Only intercept 401s; skip the refresh endpoint to avoid infinite loops
      if (error.status !== 401 || req.url.includes('/Auth/RefreshToken') || req.url.includes('/Auth/Login')) {
        return throwError(() => error);
      }

      // Attempt a silent token refresh then retry the original request once
      return authService.refreshToken().pipe(
        switchMap(() => next(req)),
        catchError(refreshError => throwError(() => refreshError))
      );
    })
  );
};
